export default "__VITE_ASSET__C4F1Hzk8__"